module.exports = __webpack_public_path__ + "static/media/slider_porque_icon1.61fc1158.svg";